export default {
  'pages.trafficstars.loadFailed': '読み込みに失敗しました',
  'pages.trafficstars.saveSuccess': '保存しました',
  'pages.trafficstars.saveFailed': '保存に失敗しました',
  'pages.trafficstars.editTitle': 'TrafficStars S2S を編集',
  'pages.trafficstars.createTitle': 'TrafficStars S2S を新規作成',
  'pages.trafficstars.back': '一覧に戻る',
  'pages.trafficstars.loadError':
    '読み込めませんでした。ページを再読み込みしてください。',
  'pages.trafficstars.name': '設定名',
  'pages.trafficstars.nameRequired': '設定名を入力してください',
  'pages.trafficstars.namePlaceholder': '例：スポーツ LP のボタンクリック',
  'pages.trafficstars.landingPage': '連携するランディングページ',
  'pages.trafficstars.pageRequired': 'ランディングページを選択してください',
  'pages.trafficstars.pagePlaceholder':
    '通常または AI ランディングページを選択',
  'pages.trafficstars.standardPage': '通常',
  'pages.trafficstars.key': 'ポストバックキー（key）',
  'pages.trafficstars.keyRequired': 'ポストバックキーを入力してください',
  'pages.trafficstars.keyEditHelp':
    '保存済みのキーは表示されません。空欄で現在のキーを保持します。',
  'pages.trafficstars.keyHelp':
    'TrafficStars で生成した S2S ポストバック設定から key をコピーして入力してください。',
  'pages.trafficstars.keyEditPlaceholder': '空欄で現在のキーを保持',
  'pages.trafficstars.keyPlaceholder': 'URL 全体ではなく key の値を入力',
  'pages.trafficstars.goalOptional': '目標 ID（goalid、任意）',
  'pages.trafficstars.goalInvalid': '目標 ID は数字で入力してください',
  'pages.trafficstars.goalPlaceholder': '例：5714',
  'pages.trafficstars.valueOptional': 'コンバージョン収益（value、任意）',
  'pages.trafficstars.priceOptional': 'コンバージョン費用（price、任意）',
  'pages.trafficstars.amountPlaceholder': '例：0.50',
  'pages.trafficstars.amountHelp':
    '各ポストバックでこの金額を送信します。空欄の場合は送信しません。',
  'pages.trafficstars.amountInvalid': '0 以上の数値を入力してください',
  'pages.trafficstars.error.invalidValue':
    'value はプレースホルダーではなく、0 以上の数値を入力してください',
  'pages.trafficstars.error.invalidPrice':
    'price はプレースホルダーではなく、0 以上の数値を入力してください',
  'pages.trafficstars.remark': '備考',
  'pages.trafficstars.active': 'ポストバックを有効にする',
  'pages.trafficstars.allowDuplicates': '重複を許可',
  'pages.trafficstars.save': '設定を保存',
  'pages.trafficstars.requestSuccess': 'ポストバックのリクエストが成功しました',
  'pages.trafficstars.retryStillFailed':
    '再送信も失敗しました。応答の詳細を確認してください。',
  'pages.trafficstars.retryFailed': '再送信に失敗しました',
  'pages.trafficstars.time': '日時',
  'pages.trafficstars.goalId': '目標 ID',
  'pages.trafficstars.defaultLead': 'デフォルトの Lead',
  'pages.trafficstars.button': 'ボタン',
  'pages.trafficstars.status': '状態',
  'pages.trafficstars.success': 'リクエスト成功',
  'pages.trafficstars.failed': '失敗',
  'pages.trafficstars.pending': '処理中',
  'pages.trafficstars.attempts': '試行回数',
  'pages.trafficstars.actions': '操作',
  'pages.trafficstars.details': '詳細',
  'pages.trafficstars.retryTitle': 'このポストバックを再送信しますか？',
  'pages.trafficstars.retryHelp':
    '元の Click ID と lead_code で再送信します。重複の計上は TrafficStars が判断します。処理中の記録は 1 分経過後に再送信できます。',
  'pages.trafficstars.retry': '再送信',
  'pages.trafficstars.statsTitle': 'TrafficStars ポストバック履歴',
  'pages.trafficstars.attributionHelp':
    '「リクエスト成功」は API が成功応答を返したことを示します。実際のアトリビューションは TrafficStars の統計と S2S Test で確認してください。',
  'pages.trafficstars.allStatuses': 'すべての状態',
  'pages.trafficstars.detailTitle': 'ポストバックの詳細',
  'pages.trafficstars.pageUrl': 'ランディングページ',
  'pages.trafficstars.response': '応答 / エラー',
  'pages.trafficstars.emptyResponse': '応答本文なし',
  'pages.trafficstars.identifier': '識別子',
  'pages.trafficstars.buttonClick': 'ボタンのクリック',
  'pages.trafficstars.listSubtitle':
    'LP のボタンクリックを計測し、TrafficStars にコンバージョンを送信',
  'pages.trafficstars.listHeader': 'ポストバック設定一覧',
  'pages.trafficstars.copyFailed': 'コピーに失敗しました',
  'pages.trafficstars.error.notFound':
    '設定が見つからないか、アクセス権がありません',
  'pages.trafficstars.error.invalidKey':
    '有効なポストバックキーを入力してください',
  'pages.trafficstars.error.missingKey':
    'TrafficStars のポストバックキーを入力してください',
  'pages.trafficstars.error.invalidGoal':
    'プレースホルダーではなく、TrafficStars の目標の数値 ID を入力してください',
  'pages.trafficstars.error.inactive': 'この設定は無効です',
  'pages.trafficstars.error.recordMissing': 'ポストバック履歴が見つかりません',
  'pages.trafficstars.error.notRetryable':
    'この記録は成功済み、または処理中です',
};
